export enum VerifyOrLogoutColor {
    PRIMARY = "PRIMARY",
    RED = "RED",
}

export interface VerifyOrLogout {
    url: string;
    cta: string;
    engagementTarget: string;
    color: VerifyOrLogoutColor;
}

export interface LanguageEnabled {
    language: string;
    enabled: boolean;
}

export interface PatientAppAuthContext {
    csrfToken: string;
}

export interface PatientAppLocaleContext {
    locale: string;
    setLanguageUrl: string;
}

export interface PatientAppHelpCenterContext {
    visible: boolean;
    helpCenterSidePanelVisible: boolean | null;
}

export interface PatientAppChatContext {
    enabled: boolean;
}

export interface PatientAppMenuContext {
    providerLogoUrl: string | null;
    notificationCenterUrl: string | null;
    preVisitAllVisitsUrl: string | null;
    financialAssistanceUrl: string | null;
    insuranceUrl: string | null;
    insuranceConsentUrl: string | null;
    verifyOrLogout: VerifyOrLogout | null;
    notifyAboutInvalidOrMissingContactInfo: boolean;
}

export interface PatientAppPaymentOptionsContext {
    payPartialUrl: string | null;
    payTotalUrl: string | null;
    paymentPlanCta: string | null;
    paymentPlanUrl: string | null;
    visible: boolean;
}

export interface PatientAppBillingMenuContext {
    visible: boolean;
    allBillsUrl: string | null;
    statementHistoryUrl: string | null;
    paymentHistoryUrl: string | null;
}

export interface PatientAppBannerContext {
    isProviderViewing: boolean;
    showPhiBanner: boolean;
}
